import type * as lazyFullOption from './lazyFullOption';
import { optionTitle_quickSteps, optionSearch_quickSteps } from './QuickStepsOption.locstring.json';
import type { LazyOption } from 'owa-options-core';
import { createLazyOption } from 'owa-options-core';
import { LazyModule, LazyAction } from 'owa-bundling';
import { getEnterpriseOrPremiumLicenseStatus } from 'owa-has-enterprise-or-premium-license-store';

const lazyModule: LazyModule<typeof lazyFullOption> = new LazyModule<typeof lazyFullOption>(
    () => import('./lazyFullOption'),
    {
        name: 'QuickStepsOption',
    }
);

const QuickStepsOption: LazyOption = createLazyOption(
    {
        key: 'QuickSteps',
        titleStringKey: optionTitle_quickSteps,
        isTitleHidden: () => true,
        searchTermsStringKey: optionSearch_quickSteps,
        isHidden: () => {
            return getEnterpriseOrPremiumLicenseStatus() != 'HasEnterpriseOrPremiumLicense';
        },
        copilotSettingKey: 'quicksteps',
    },
    lazyModule,
    m => m.default
);

export default QuickStepsOption;

export const lazyCreateNewQuickStep: LazyAction<
    typeof lazyFullOption.createNewQuickStepMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createNewQuickStepMutator);
